import React from 'react';

import Suspense from '@atlaskit/react-ufo/suspense';
import { SideNavProvider } from '@atlassian/conversation-assistant';

// Lazy load the RovoSidebarNavigation to avoid pulling in @atlassian/rovo-navigation
// unless the Rovo chat experiment is actually enabled
const RovoSidebarNavigation = React.lazy(() =>
	import('./RovoSidebarNavigation').then((module) => ({
		default: module.RovoSidebarNavigation,
	})),
);

export const LazyRovoSidebarNavigation = () => {
	const content = (
		<Suspense interactionName="rovo-sidebar-navigation" fallback={null}>
			<RovoSidebarNavigation />
		</Suspense>
	);

	return <SideNavProvider>{content}</SideNavProvider>;
};
